/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {reportClientActivityPageDisplayed} from '../api'

export const useMutationReportClientActivityPageDisplayed = createReactQueryMutationHook('reportClientActivityPageDisplayed', reportClientActivityPageDisplayed)
